/**
 * The overview's route path. `./routes.ts` registers it, and the default
 * surface after sign-in redirects to it through `overviewPath`, so nothing else
 * spells the literal.
 *
 * Relative to the router's `basepath`, like every other route literal in this
 * plane.
 */

import { interpolatePath } from '@tanstack/react-router';

export const OVERVIEW_PATH = '/c/$campaignId/overview';

/** `OVERVIEW_PATH` filled in, for a caller that needs a plain href rather than
 *  a typed `<Link>`. */
export function overviewPath(campaignId: string): string {
  return interpolatePath({ path: OVERVIEW_PATH, params: { campaignId } }).interpolatedPath;
}
